
export const getAgeString = (difference, dictionary) => {
  if (difference.years < 0 || difference.months < 0 || difference.days < 0){
    return "Error";
  }

  return replaceDateString(
    difference,
    getDateDictionaryString(difference, dictionary)
  );
}

const getDateDictionaryString = (difference, dictionary) => {

  // Get day(s)
  if (difference.years === 0 && difference.months === 0){
    if (difference.days === 1)
      return dictionary.day;
    return dictionary.days;
  }

  // Get month(s) day(s)
  if (difference.years === 0){

    if (difference.days === 0) {
      if (difference.months === 1)
        return dictionary.month;
      return dictionary.months;
    }

    if (difference.months === 1){
      if (difference.days === 1)
        return dictionary.monthDay;
      return dictionary.monthDays;
    } 

    if (difference.days === 1)
      return dictionary.monthsDay;
    return dictionary.monthsDays;
  }

  // Get year(s) month(s)
  if (difference.years === 1){
    if (difference.months == 0)
      return dictionary.year;

    if (difference.months === 1)
      return dictionary.yearMonth;

    return dictionary.yearMonths;
  }

  if (difference.months == 0)
    return dictionary.years;

  if (difference.months === 1)
    return dictionary.yearsMonth;

  return dictionary.yearsMonths;
}

const replaceDateString = (difference, string) => {
  if (!string){
    return null;
  }

  let output = string;
  output = output.replace("{YY}", difference.years);
  output = output.replace("{MM}", difference.months);
  output = output.replace("{DD}", difference.days);
  
  return output;
}

export const getDateFormat = (type = null) => {
  if (type === null)
    return "DD-MM-YYYY";

  switch (type){
    case "ymd":
      return "YYYY/MM/DD";
  }
}